import { Briefcase, Building2, ChevronDown, LayoutGrid } from "lucide-react";
import { Field } from "@/components/kit";
import { useCategories } from "@/hooks/queries";

export function validateBusiness(b) {
  const e = {};
  if (!b.businessCategoryId) e.businessCategoryId = "Please select your business category.";
  if (!b.companyName.trim()) e.companyName = "Please enter your company name.";
  else if (b.companyName.trim().length > 200) e.companyName = "Company name must be 200 characters or fewer.";
  if (!b.designation.trim()) e.designation = "Please enter your designation.";
  else if (b.designation.trim().length > 120) e.designation = "Designation must be 120 characters or fewer.";
  return e;
}
export const cleanBusiness = (b) => ({ businessCategoryId: b.businessCategoryId, companyName: b.companyName.trim(), designation: b.designation.trim() });

export default function BusinessFields({ value, onChange, errors = {}, prefix }) {
  const cats = useCategories();
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <>
      <label className="block">
        <span className="t-label">Business Category *</span>
        <span className="relative block">
          <LayoutGrid className="absolute left-4 top-[15px] w-5 h-5 text-[#64748B] pointer-events-none" strokeWidth={1.8} />
          <select className={`t-input pl-12 pr-10 appearance-none text-[15px] ${value.businessCategoryId ? "" : "text-[#64748B]"} ${errors.businessCategoryId ? "border-[#DC2626]" : ""}`}
            value={value.businessCategoryId} onChange={set("businessCategoryId")} data-testid={`${prefix}-business-category`}>
            <option value="">Select your business category</option>
            {(cats.data ?? []).filter((c) => c.status === "active").map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <ChevronDown className="absolute right-4 top-[15px] w-5 h-5 text-[#475569] pointer-events-none" />
        </span>
        {errors.businessCategoryId && <span className="block mt-1.5 text-[13px] text-[#DC2626]">{errors.businessCategoryId}</span>}
      </label>
      <Field label="Company Name *" icon={Building2} placeholder="Your company or business name" value={value.companyName} onChange={set("companyName")} error={errors.companyName} maxLength={200} testid={`${prefix}-company`} />
      <Field label="Designation *" icon={Briefcase} placeholder="e.g. Founder, Manager, Consultant" value={value.designation} onChange={set("designation")} error={errors.designation} maxLength={120} testid={`${prefix}-designation`} />
    </>
  );
}
